import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

import {ROUTE} from '../config'
import Icon from '../components/Icon'

import '../styles/NavBar.scss'

export default class NavBar extends Component {
  static propTypes = {
    baseRoute: PropTypes.string.isRequired,
    explore: PropTypes.bool,
    topPicks: PropTypes.bool,
    favorites: PropTypes.bool
  }

  static defaultProps = {
    explore: false,
    topPicks: false,
    favorites: false
  }

  render() {
    const { explore, topPicks, favorites } = this.props

    return <div className="NavBar">
      {explore && <NavLink className="nav-link" to={`${this.props.baseRoute}${ROUTE.EXPLORE}`}><Icon type="binocular"/>Explorar</NavLink>}
      <NavLink className="nav-link" to={`${this.props.baseRoute}${ROUTE.BROWSE}`}><Icon type="book"/>Manuales</NavLink>
      <NavLink className="nav-link" to={`${this.props.baseRoute}${ROUTE.SEARCH}`}><Icon type="search-dot"/>Buscar</NavLink>
      {topPicks && <NavLink className="nav-link" to={`${this.props.baseRoute}${ROUTE.TOPPICKS}`}><Icon type="flag"/>Mejores selecciones</NavLink>}
      {favorites && <NavLink className="nav-link" to={`${this.props.baseRoute}${ROUTE.FAVORITES}`}><Icon type="bookmark"/>Favoritos</NavLink>}
    </div>
  }
}
